import { apiClient } from './client';
import type { ApiResponse, LoginResponse, RegisterResponse, User } from '@/types/api.types';

export const authApi = {
  login: (email: string, password: string) =>
    apiClient.post<ApiResponse<LoginResponse>>('/auth/login', { email, password }),

  register: (data: {
    tenantName: string;
    tenantSlug: string;
    name: string;
    email: string;
    password: string;
  }) => apiClient.post<ApiResponse<RegisterResponse>>('/auth/register', data),

  refresh: (refreshToken: string) =>
    apiClient.post<ApiResponse<{ accessToken: string; refreshToken: string }>>(
      '/auth/refresh',
      { refreshToken },
    ),

  logout: (refreshToken: string) =>
    apiClient.post('/auth/logout', { refreshToken }),

  me: () => apiClient.get<ApiResponse<User>>('/auth/me'),
};
